import { Stack, Typography } from "@mui/material";

export interface TableCell3LinesProps {
  title: string;
  desc: string;
  bottom?: string;
}

const TableCell3Lines: React.FC<TableCell3LinesProps> = ({ title, desc, bottom }) => {
  return (
    <Stack p={0.5}>
      <Typography fontWeight={500} sx={{}}>
        {title}
      </Typography>
      <Typography color="text.secondary" variant={"body2"} sx={{}}>
        {desc}
      </Typography>
      {bottom && (
        <Typography color="info.main" variant={"body2"} mt={0.5} sx={{}}>
          {bottom}
        </Typography>
      )}
    </Stack>
  );
};

export default TableCell3Lines;
